// import { mountNavigation } from '@apps/navigation/index.js';
import { mountCourseDetail } from '@apps/course-detail/index.js';

console.log('Course page script loading...');

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM ready, mounting apps...');
    
    // // Mount navigation
    // const navResult = mountNavigation('nav-app');
    // console.log('Navigation mount result:', navResult);

    // Mount course detail app
    const appResult = mountCourseDetail('app');
    console.log('Course detail mount result:', appResult);
});

// Also try immediate mounting in case DOM is already ready
if (document.readyState === 'loading') {
    console.log('Document still loading, waiting for DOMContentLoaded...');
} else {
    console.log('Document already loaded, mounting immediately...');
    // mountNavigation('nav-app');
    mountCourseDetail('app');
}
